<div class="form-action-buttons"
    [ngClass]="{'justify-center': justify === 'center' }">
    <ng-content></ng-content>
</div>
